import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { findDOMNode } from 'react-dom';
import { Link } from 'react-router';
import ImportIcon from 'material-ui/svg-icons/communication/import-export';
import { updateSuppProfileProps } from '../../../stores/profile/company/profile-actions';
import R, { contains, either, isEmpty, isNil, not, path } from 'ramda';
import moment from 'moment';
import ProfileImage from '../../app-bar/profile-image';
import { FontIcon, IconButton, IconMenu, MenuItem } from "material-ui";
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
const isNilOrEmpty = either(isNil, isEmpty);

class ListLink extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tooltipShown: false,
      showFullTitle: false,
    };
  }

  componentDidMount() {
    this.showFullTitleAfterMount();
    this.setState({
      showFullTitle: Boolean(findDOMNode(this.refs.listLink) && findDOMNode(this.refs.outerContainer) && (findDOMNode(this.refs.listLink).offsetWidth === findDOMNode(this.refs.outerContainer).offsetWidth))
    });
  }

  showFullTitleAfterMount = () => {
    const shouldShowFullTitle = Boolean(
      findDOMNode(this.refs.listLink) &&
      findDOMNode(this.refs.outerContainer) &&
      findDOMNode(this.refs.listLink).offsetWidth === findDOMNode(this.refs.outerContainer).offsetWidth
    );
    this.setState({
      showFullTitle: shouldShowFullTitle,
    });
  };

  _showTooltip = () => {
    this.setState({ tooltipShown: true });
  };

  _hideTooltip = () => {
    this.setState({ tooltipShown: false });
  };

  _handleMouseLeave = () => {
    this._hideTooltip();
  };

  _handleMouseEnter = () => {
    this._showTooltip();
  };

  render() {
    const { item, locationOrProduct, isEditable, routeName, borderBottom, updateProp } = this.props;
    const listNameStyles = {
      maxWidth: (locationOrProduct.isMarketingReady && isEditable) ? '70%' : '90%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'inline-block',
      textOverflow: 'ellipsis',
      paddingBottom: '2px',
    };
    const extraStyles = {};
    if (this.state.showFullTitle) {
      extraStyles.clear = 'both';
      extraStyles.overflow = 'hidden';
    }

    if (item === 'location') {
      extraStyles.position = 'relative';
      extraStyles.top = '-5px';
    }

    const isMarketingReady = () => {
      const isProfilOrLocationRoute = routeName === 'profile' || routeName === 'location';
      if (!isProfilOrLocationRoute) return <div/>;
      if (locationOrProduct.isMarketingReady && isEditable) return (<div style={extraStyles} className="location-content-contract-readiness">Published</div>);
      if (!locationOrProduct.isMarketingReady && isEditable) return (<div style={extraStyles} className="location-content-contract-readiness-draft">Draft</div>);
    };
    let numberOfProducts;
    if (item === 'location') {
      let label = 'PRODUCT';
      if (locationOrProduct.numOfProducts !== 1) {
        label += 'S';
      }
      const updatedAt = locationOrProduct.products.map(p => p.updatedAt).reduce((result, date) => {
        return moment(date).isAfter(result) ? date : result;
      }, locationOrProduct.updatedAt);
      numberOfProducts = (
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '24px' }}>
          <div style={{ display: 'flex', alignItems: 'baseline' }}>
            <span style={{ fontSize: '20px' }}>{locationOrProduct.numOfProducts}</span>
            <span style={{ fontSize: '12px', marginLeft: '4px' }}>{label}</span>
          </div>
          <small>{moment(updatedAt).format('l')}</small>
        </div>
      );
    } else {
      numberOfProducts = (<small>{moment(locationOrProduct.updatedAt).format('l')}</small>);
    }

    const findPhotoForLocOrProd = (locOrProdId) => {
      const allFiles = this.props.profile.media || [];
      const findFilesForId = allFiles.filter(file => contains((locOrProdId || '').toString(), file.tags) && (file.mediaType === 'image/jpeg' || file.mediaType === 'image/png'));
      if (not(isNilOrEmpty(findFilesForId))) return path([0, 'url'], findFilesForId);
    };
    const linkType = item === 'product' ? 'product' : 'locations';
    return (
      <div className="location-name">
        <div
          style={{
            height: '80px',
            position: 'relative',
            display: 'block',
            clear: 'both',
            float: 'left',
            padding: '16px',
          }}
        >
          <ProfileImage
            className="profile-image"
            companySlugName={locationOrProduct.name}
            imageUrl={findPhotoForLocOrProd(locationOrProduct.id)}
          />
        </div>
        <div style={{
          borderBottom,
        }} className="location-content flex-tc-sb"
        >
          {
            (() => {
              if (item === 'location') {
                const addressInfo = [locationOrProduct.city, locationOrProduct.state, locationOrProduct.country];
                const addressString = addressInfo.reduce((string, addressPiece, index) => {
                  let stringToReturn = string;
                  if (addressPiece) {
                    stringToReturn += addressPiece;
                    if (index !== 2) stringToReturn += ', ';
                  }
                  return stringToReturn;
                }, '');
                return (
                  <div
                    style={{
                      width: '75%',
                      maxHeight: '48px',
                      position: 'relative',
                      display: 'inline-block',
                    }}
                  >
                    <h5
                      onMouseEnter={this._handleMouseEnter}
                      onMouseLeave={this._handleMouseLeave}
                      ref="listLink"
                      className="location-content-link"
                      style={listNameStyles}
                    >
                      <Link
                        to={isEditable || (routeName === 'profile' && !R.contains('company', location.pathname.split('/'))) ? `/profile/locations/${locationOrProduct.id}` : `/locations/${locationOrProduct.id}`}
                      >
                        {locationOrProduct.name}
                      </Link>
                    </h5>
                    {isMarketingReady()}
                    {
                      Boolean(addressString) && <div className="location-list-content">{addressString}</div>
                    }
                  </div>
                );
              }

              if (item === 'product') {
                const productStyle = ({
                  verticalAlign: 'middle',
                  lineHeight: '48px',
                  fontSize: '20px',
                  fontWeight: '300',
                  maxWidth: locationOrProduct.isMarketingReady && isEditable ? '75%' : '100%',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                });
                return (
                  <div
                    style={{
                      width: '90%',
                      maxHeight: '48px',
                      display: 'inline-block',
                    }}
                  >
                    {this.state.showFullTitle ?
                      <span>{locationOrProduct.name}</span> : undefined}
                    <h5 style={productStyle} ref="listLink" className="location-content-link">
                      <Link to={isEditable || R.contains('profile', location.pathname.split('/')) ? `/profile/product/${locationOrProduct.id}` : `/product/${locationOrProduct.id}`} >
                        {locationOrProduct.name}
                      </Link>
                    </h5>
                    {isMarketingReady()}
                    <div className="location-list-content product-paragraph"/>
                  </div>
                );
              }
            })()
          }
          <div style={{
            width: 'auto',
            display: 'flex',
            alignItems: 'center',
            maxHeight: '48px',
            lineHeight: '48px',
            marginRight: '8px',
          }}
          >
            <div style={{ display: 'flex', alignItems: 'center', verticalAlign: 'middle' }}>
              {numberOfProducts}
            </div>
            {isEditable ? (
              <Link to={isEditable ? `/profile/${linkType}/${locationOrProduct.id}` : `/${linkType}/${locationOrProduct.id}`} >
                <IconButton
                  iconClassName="tc-icon-mode_edit"
                  tooltip="Edit"
                  tooltipPosition="top-center"
                  tooltipStyles={{ top: '30px' }}
                  iconStyle={{ fontSize: '20px', color: 'rgba(0, 0, 0, 0.54)', marginRight: '-5px' }}
                  hoveredStyle={{ color: '#00bcd4' }}
                />
              </Link>
            ) : null}
            {isEditable ? (
              <IconMenu
                style={{ display: 'flex' }}
                iconButtonElement={<IconButton><MoreVertIcon style={{ color: '#616061' }} /></IconButton>}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                targetOrigin={{ horizontal: 'right', vertical: 'top' }}
              >
                <MenuItem
                  leftIcon={<ImportIcon style={{ color: 'rgba(0, 0, 0, 0.54)' }}/>}
                  primaryText="Import Data"
                  key="Import Data"
                  onTouchTap={() => {
                    updateProp({ itemToImport: {}, importDataOpen: !this.props.profile.importDataOpen, idToImportTo: locationOrProduct.id });
                  }}
                />
                <MenuItem
                  leftIcon={<FontIcon className="tc-icon-delete2" color="rgba(0, 0, 0, 0.54)" style={{ fontSize: '24px' }} />}
                  primaryText="Delete"
                  key="Delete"
                  onTouchTap={this.props._confirmRemoveItem}
                />
              </IconMenu>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

ListLink.propTypes = {
  profile: PropTypes.object,
  item: PropTypes.string,
  locationOrProduct: PropTypes.object,
  isEditable: PropTypes.bool,
  routeName: PropTypes.string,
  updateProp: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateSuppProfileProps(...args)),
});

export default connect(null, mapDispatchToProps)(ListLink);



// WEBPACK FOOTER //
// ./src/app/components/profile/location-or-product-list/list-link.jsx